export const oxgScrollToTop = (element = null, pos = 0, behavior = 'smooth') => {
    if(!element) { element = document.body }
    if(typeof(behavior != 'string' )) { behavior = 'smooth' }
    if(typeof(pos != 'number' || pos != 'integer' )) { pos = 0 }
    if (behavior == 'smooth' || 'auto') {
        element.scrollTo({ top: pos, behavior: 'smooth' })
    } else {
        element.scrollTop = pos
    }
}

export const oxgScrollTo = ({ element, offset = 0, behavior = 'smooth', callback = () => {} } = {}) => {
    if (!element) return;

    // Get the element's Y position relative to the document
    const elementRect = element.getBoundingClientRect();
    const elementY = window.scrollY + elementRect.top;

    // Scroll to the element's position with the specified offset and behavior
    if (behavior === 'auto') {
        // Instant scroll without smooth behavior
        window.scrollTo(0, elementY - offset);
        callback(); // Execute the callback immediately
    } else {
        // Smooth scrolling
        window.scrollTo({
            top: elementY - offset,
            behavior: behavior
        });

        // Create an intersection observer to detect when the element is in view
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    observer.disconnect(); // Stop observing
                    callback(); // Execute the callback
                }
            });
        }, {
            threshold: 1.0  // The element must be fully visible
        });

        observer.observe(element);
    }
};




export function oxgScrollToChild(parent, child, offset = 0, callback = null) {
  // Calculate the position and dimensions of the parent and child nodes
  const parentRect = parent.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();
  const parentScrollTop = parent.scrollTop;

  // Determine the desired scroll positions to make the child fully visible
  const scrollTopToTop = Math.max(childRect.top - parentRect.top + parentScrollTop + offset, 0);
  const scrollTopToBottom = Math.max(childRect.bottom - parentRect.bottom + parentScrollTop + offset, 0);

  // Check if the child node is already fully visible within the parent
  const isChildFullyVisible = (
      childRect.top >= parentRect.top &&
      childRect.bottom <= parentRect.bottom
  );

  // Only scroll if the child node is not fully visible
  if (!isChildFullyVisible) {
      // Determine whether to scroll up or down
      let scrollTop;
      if (childRect.top < parentRect.top) {
          // Scroll up to the top of the child node
          scrollTop = scrollTopToTop;
      } else {
          // Scroll down to the bottom of the child node
          scrollTop = scrollTopToBottom;
      }

      // Smooth scroll the parent to the calculated position
      parent.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
      });

      // If a callback function is provided, set up an event listener to call it once scrolling is complete
      if (typeof callback === 'function') {
          // Add a scroll event listener to check if the scroll is done
          const checkIfScrollDone = () => {
              if (Math.abs(parent.scrollTop - scrollTop) < 1) { // Use a small threshold for floating point precision issues
                  parent.removeEventListener('scroll', checkIfScrollDone);
                  callback();
              }
          };

          // Add the event listener
          parent.addEventListener('scroll', checkIfScrollDone);
      }
  } else if (typeof callback === 'function') {
      // If the child is already fully visible, call the callback immediately
      callback();
  }
}